var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoNotext = function SvgLogoNotext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-name": "Layer 1",
    viewBox: "0 0 50.511 40.851"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M31.23 40.851v-.002l-.001.002"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M50.51 3.4V0H0v36.194h22.412a5.44 5.44 0 0 1 5.196 3.899l.221.756v.002h3.4v-.002l.221-.756a5.44 5.44 0 0 1 5.196-3.899h13.795V13.58H36.646c-2.923 0-5.512 1.436-7.117 3.634-1.605-2.198-4.193-3.634-7.117-3.634H8.618v14.129h3.4v-10.73h10.394a5.424 5.424 0 0 1 5.417 5.418v12.275a8.8 8.8 0 0 0-5.417-1.877H3.4V3.4zM31.23 22.396a5.424 5.424 0 0 1 5.416-5.417h10.395v15.815H36.646a8.8 8.8 0 0 0-5.417 1.877z"
  })));
};
export default SvgLogoNotext;